import BuildingType from '@/roc/building/BuildingType';
import Effects from '@/roc/effects/Effects';
import ProductionCurrency from '@/roc/effects/Production/ProductionCurrency';
import ProductionOutputType from '@/roc/effects/Production/ProductionOutputType';
import ChestItem from '@/roc/effects/Production/ChestItem';
import ProductionQueue from '@/roc/effects/Production/ProductionQueue';
import ProductionWorkforce from '@/roc/effects/Production/ProductionWorkforce';
import ProductionCost from '@/roc/effects/Production/ProductionCost';
import ProductionDuration from '@/roc/effects/Production/ProductionDuration';
import ProductionOutput from '@/roc/effects/Production/ProductionOutput';
import PassiveAura from '@/roc/effects/PassiveAura/PassiveAura';
import PassiveAuraType from '@/roc/effects/PassiveAura/PassiveAuraType';
import EffectAmount from '@/roc/effects/EffectAmount';

const LakePagoda = {
  id: '159',
  name: 'Lake Pagoda',
  width: 2,
  height: 2,
  type: BuildingType.COLLECTABLE,
  era: 'stoneAge',
  icon: 'Lake_Pagoda',
  minLevel: 1,
  maxLevel: 40,
  url: 'https://riseofcultures.wiki.gg/wiki/Buildings/Lake_Pagoda',
  flags: 0,
  counts: null,
  effects: Effects.create([
    new PassiveAura(
      PassiveAuraType.GRANTS_CAPITAL_CITY_WORKER,
      EffectAmount.asPerLevel([
        1,1,1,1,1,1,2,2,2,2,
        2,2,3,3,3,3,3,4,4,4,
        4,4,4,5,5,5,5,5,6,6,
        6,6,6,6,7,7,7,7,7,8,
      ])
    ),
    new ProductionQueue(
      ProductionWorkforce.asFlat(4),
      [
        ProductionCost.asPerLevel([
          350, 346, 343, 339, 336, 333, 330, 327, 324, 321,
          318, 315, 312, 309, 307, 304, 301, 299, 296, 294,
          291, 289, 286, 284, 282, 280, 277, 275, 273, 271,
          269, 267, 265, 263, 261, 259, 257, 255, 253, 251,
        ]).withCurrency(ProductionCurrency.CURRENT_ERA_SECONDARY_GOODS),
      ],
      ProductionDuration.asCallbackWithLevel(
        (level) => {
          return 24 * 60 * 60 - ((level - 1) * 15 * 60);
        }
      ),
      ProductionOutput.asFlat(1).withOutput(ProductionOutputType.CHEST).withItems([
        ChestItem.asFlat(1).withChance(20.0).withOutput(ProductionOutputType.NEGOTIATION_JOKER),
        ChestItem.asFlat(1).withChance(10.0).withOutput(ProductionOutputType.RESEARCH_POINTS),
        ChestItem.asFlat(2).withChance(10.0).withOutput(ProductionOutputType.RESEARCH_POINTS),
        ChestItem.asFlat(3).withChance(15.0).withOutput(ProductionOutputType.RESEARCH_POINTS),
        ChestItem.asFlat(5).withChance(15.0).withOutput(ProductionOutputType.RESEARCH_POINTS),
        ChestItem.asFlat(7).withChance(15.0).withOutput(ProductionOutputType.RESEARCH_POINTS),
        ChestItem.asFlat(10).withChance(15.0).withOutput(ProductionOutputType.RESEARCH_POINTS),
      ])
    )
  ]),
};

export default LakePagoda;
